export const ERROR_NAME = 'AccountGuidError'

export class AccountGuidError extends Error {
  constructor(message) {
    super(message || 'Invalid Account Guid')
    this.name = ERROR_NAME
  }
}

export default AccountGuidError
